<template>
  <v-alert
    @input="onClose"
    dismissible
    type="error"
    :value="true"
    outline
  >
  {{text}}
  </v-alert>
</template>

<script>
export default {
  props: ["text"],
  methods: {
    onClose() {
      this.$emit("dismissed");  //this is an event. I call it in Signin with "@dismissed"
    }
  }
};
</script>